import home from './home-paje.json'

export default {
  ...home
}